"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandSetupOverlay = void 0;
var moment_1 = __importDefault(require("moment"));
var attachBrandSetupComponent_1 = require("./attachBrandSetupComponent");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var format = "h:mm a, MMMM D YYYY";
var BrandSetupOverlay = (function () {
    function BrandSetupOverlay(di, $timeout, createUi, overlayStack, account, user, Button, initSubscription, brandStore, stylePermissionStore, uploadStore, fontService, telemetry, serverTelemetry) {
        var _this = this;
        var brandSetupOverlay = require("./brandSetupOverlay.html");
        var adminName = "".concat(user.firstName, " ").concat(user.lastName);
        var explorePlans = function () { return initSubscription.init(); };
        var useSameFontToggled = brandStore.useSameFont;
        var checkBrandSettingUpdate = function () {
            var sameFontToggleUpdated = useSameFontToggled !== brandStore.useSameFont;
            var hasUpdate = sameFontToggleUpdated || brandStore.hasChanges || stylePermissionStore.hasChanges;
            if (hasUpdate === _this.ui.hasUpdate) {
                return;
            }
            _this.ui.hasUpdate = hasUpdate;
            $timeout();
        };
        setInterval(checkBrandSettingUpdate, 500);
        var closeOverlay = function () {
            overlayStack.closeCurrent();
        };
        var saveUpdate = function () {
            serverTelemetry.sendBrandConfiguredTelemetry({
                eventProperties: {},
                eventOrigin: event_tracker_types_1.EventOrigin.QwilrBrandSettings,
            });
            brandStore.saveBrandSettingUpdate(adminName);
            stylePermissionStore.savePermissionUpdate();
            fontService.loadFonts();
            useSameFontToggled = brandStore.useSameFont;
            closeOverlay();
        };
        var cancelUpdate = function () {
            brandStore.revertChanges();
            stylePermissionStore.revertChanges();
            closeOverlay();
        };
        var closeButton = new Button(closeOverlay, "close", {
            theme: "primary",
            size: "small",
            initialState: "idle",
        });
        var cancelButton = new Button(cancelUpdate, "cancel", {
            theme: "secondary",
            size: "small",
            initialState: "idle",
        });
        var updateButton = new Button(saveUpdate, "update brand", {
            theme: "primary",
            size: "small",
            initialState: "idle",
        });
        this.ui = createUi(brandSetupOverlay, {
            brandSetupContainer: di.convoke(attachBrandSetupComponent_1.attachBrandSetupComponent, null, {
                brandStore: brandStore,
                stylePermissionStore: stylePermissionStore,
                uploadStore: uploadStore,
                explorePlans: explorePlans,
                fontService: fontService,
                onDestroy: function () {
                    clearInterval(setInterval(checkBrandSettingUpdate, 500));
                },
            }),
            hasUpdateState: function () { return !!account.settings.brand.updateAt && !!account.settings.brand.updateBy; },
            getLastUpdateTime: function () { return (0, moment_1.default)(account.settings.brand.updateAt).format(format); },
            getLastUpdateBy: function () { return account.settings.brand.updateBy; },
            hasUpdate: false,
            closeButton: closeButton,
            cancelButton: cancelButton,
            updateButton: updateButton,
        });
        this.show = function () {
            telemetry.trackOnly("Account Brand Viewed");
            $timeout(function () {
                overlayStack.add({
                    contentUi: _this.ui,
                    options: {
                        centerContent: false,
                        hideCloseButton: true,
                    },
                });
            });
        };
    }
    return BrandSetupOverlay;
}());
exports.BrandSetupOverlay = BrandSetupOverlay;
